import { render, staticRenderFns } from "./DebtorsList.vue?vue&type=template&id=e17634f8&"
import script from "./DebtorsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DebtorsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DebtorsList.vue?vue&type=style&index=0&id=e17634f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports